<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 13:48:42
-->
<template>
    <div>
        <!-- <a-avatar :size="25">
            <IconUser size="18"/>
            <img alt="avatar" src="https://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/3ee5f13fb09879ecb5185e440cef6eb9.png~tplv-uwbnlip3yd-webp.webp"/>
        </a-avatar> -->
        <a-dropdown class="userName">
            <a-button style="background:#fff">{{ userName }} <icon-down/></a-button>
            <template #content>
                <a-doption @click="clearCache">
                    <icon-refresh :size="16"/>
                    {{ $t('base.clearCache') }}
                </a-doption>
                <a-doption @click="logout">
                    <icon-poweroff :size="16"/>
                    {{ $t('base.logout') }}
                </a-doption>
            </template>
        </a-dropdown>
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useRouter } from 'vue-router';

    const router = useRouter()
    const userName = sessionStorage.getItem('userInfo')? ref(JSON.parse(sessionStorage.getItem('userInfo')).user_name) : ''

    const clearCache = ()=>{
    }

    const logout = ()=>{
        sessionStorage.removeItem('userInfo')
        sessionStorage.removeItem('permissionBtns')
        router.replace('/Login')
    }

    onMounted(()=>{

    })

</script>

<style lang="less" scoped>
.userName{
    cursor: pointer;
}
</style>